import React, {Component} from 'react'
import FilterStatus from './filters/FilterStatus'
import {Select} from "antd"

class BatchFilters extends Component {
    getOptionOverTime = (start, end) => {
        const Options = [
            {
                name: 'Tất cả',
                value: '',
            },
        ]
        for (let i = start; i <= end; i++) {
            if(i !== 0) {
                const Option = {
                    name: i,
                    value: i,
                }
                Options.push(Option)
            }
        }
        return Options
    }

    _handleChangeOverTime = (value) => {
        const {onChangeStatus} = this.props
        onChangeStatus('item_overtime', value)
    }

    render() {
        const {onChangeStatus} = this.props
        const {Option} = Select
        const OverTime = this.getOptionOverTime(-6,6)

        return (
            <div className='FilterOptions d-flex'>
                <FilterStatus {...this.props} />
                <div className='FilterStatus mr-4'>
                    <label className="mr-2 font-weight-bold">Quá hạn:</label>
                    <Select defaultValue={''} name="status" style={{ width: 180 }}
                        onChange={this._handleChangeOverTime}>
                        {
                            OverTime.map((item, index) =>
                                <Option key={index} value={item.value}>
                                    {item.name}
                                </Option>
                            )
                        }
                    </Select>
                </div>
            </div>
        )
    }
}

export default BatchFilters